import {
    Button as AntdButton,
    Col as AntdCol,
    Row as AntdRow,
    Form,
    Input,
    Select,
    Table,
    notification, Popconfirm, Tooltip, DatePicker, Image,
} from "antd";
import {Option} from "antd/es/mentions";
import {ColumnsType} from "antd/es/table";
import React, {useEffect, useState} from "react";
import {Card, Col, Row} from "react-bootstrap";
import CustomPagination from "../../components/CustomPagination";
import PageTitle from "../../components/PageTitle";
import { useNavigate } from 'react-router-dom';
import {searchEpisodeCaptureImage} from "../../helpers/api/episodeCaptureImage";

const { RangePicker } = DatePicker;

interface EpisodeCaptureImageModel {
    key: React.Key;
    id: string;
    userId: string;
    episodeId: string;
    title: string;
    prompt: string;
    url: string;
    seedId: number;
    isNsfw: boolean;
    level: number;
    storyName: string;
    createdAt: Date;
    modifiedAt: Date;

}

const EpisodeCaptureImage = () => {
    const navigate = useNavigate(); // Lấy đối tượng navigate

    const [pageSize, setPageSize] = useState<number>(10);
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [totalRecord, setTotalRecord] = useState<number>(0);
    const [episodeCaptureImages, setEpisodeCaptureImages] = useState<EpisodeCaptureImageModel[]>([]);

    const [api, contextHolder] = notification.useNotification();

    const [form] = Form.useForm();
    const formValueObj = Form.useWatch([], form);
    const [searchLoading, setSearchLoading] = useState<boolean>(false);



    const columns: ColumnsType<EpisodeCaptureImageModel> = [
        {
            title: "No.",
            dataIndex: "noNumber"
        },
        {
            title: "Image",
            dataIndex: "name",
            render: (text, record, index) => {
                return (
                    <span>
                            <Image
                                width={50}
                                src={record.url}
                            />
                    </span>
                )
            },
        },
        {
            title: "Prompt",
            dataIndex: "prompt",
            render: (text, record, index) => {
                return <span>{record?.prompt}</span>
            }
        },
        {
            title: "Story Name",
            dataIndex: "storyName",
            render: (text, record, index) => {
                return <span>{record?.storyName}</span>
            }
        },
        {
            title: "Level",
            dataIndex: "level",
            render: (text, record, index) => {
                return <span>{record?.level}</span>
            }
        },
        {
            title: "IsNsfw",
            dataIndex: "isNsfw",
            render: (text, record, index) => {
                return <span>{record?.isNsfw ? 'True' : 'False'}</span>
            }
        },
        {
            title: "Created at",
            dataIndex: "createdAt",
            render: (text, record, index) => {
                return <span>{record?.createdAt ? new Date(record?.createdAt).toLocaleString() : ''}</span>
            }
        },
    ];

    useEffect(() => {
        search();
    }, [pageIndex]);

    useEffect(() => {
        if (pageIndex === 1) {
            search();
            return;
        }
        setPageIndex(1);
    }, [pageSize]);

    const search = async () => {
        setSearchLoading(true);
        const searchObj: any = {
            pageIndex: pageIndex - 1,
            pageSize,
        };
        if (formValueObj?.searchingDate) {
            searchObj["fromDate"] = new Date(formValueObj?.searchingDate[0]).toISOString();
            searchObj["toDate"] = new Date(formValueObj?.searchingDate[1]).toISOString();
        }
        if (formValueObj?.isNsfw) {
            searchObj["isNsfw"] = formValueObj?.isNsfw;
        }
        if (formValueObj?.storyName) {
            searchObj["storyName"] = formValueObj?.storyName;
        }
        if (formValueObj?.episodeLevel) {
            searchObj["episodeLevel"] = formValueObj?.episodeLevel;
        }
        try {
            const response = await searchEpisodeCaptureImage(searchObj);
            if (response.status === 200) {
                const data: any[] = [];
                response.data.data.forEach((item: any, index: number) => {
                    data.push({
                        ...item,
                        noNumber: (pageIndex - 1) * pageSize + index + 1,
                    });
                });
                setEpisodeCaptureImages(data);
                setTotalRecord(response.data.totalRecord);
            }
        } catch (err) {
            console.error(err);
            api.error({
                message: `Error notification`,
                description: <span className="text-danger">{err as string || 'There\'re some errors occured!'}</span>,
                placement: 'topRight'
            });
        }
        setSearchLoading(false);
    }



    return (
        <>
            {contextHolder}
            <PageTitle
                breadCrumbItems={[
                    {label: "Episode Capture Image", path: "/episode_capture_images"},
                ]}
                title={"Episode Capture Image"}
            />

            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <Form layout="vertical" autoComplete='off' form={form}>
                                <AntdRow gutter={16}>
                                    <AntdCol span={12}>
                                        <Form.Item
                                            name="searchingDate"
                                            label="Date"
                                        >
                                            <RangePicker className="w-100" showTime />
                                        </Form.Item>
                                    </AntdCol>
                                    <AntdCol span={12}>
                                        <Form.Item
                                            name="isNsfw"
                                            label="Is NSFW"
                                        >
                                            <Select
                                                placeholder="Select"
                                                allowClear
                                            >
                                                <Option value="true">True</Option>
                                                <Option value="false">False</Option>
                                            </Select>

                                        </Form.Item>
                                    </AntdCol>
                                </AntdRow>
                                <AntdRow gutter={16}>
                                    <AntdCol span={12}>
                                        <Form.Item
                                            name="storyName"
                                            label="Story"
                                        >
                                            <Input placeholder="Please enter name"/>
                                        </Form.Item>
                                    </AntdCol>
                                    <AntdCol span={12}>
                                        <Form.Item
                                            name="episodeLevel"
                                            label="Level"
                                        >
                                            <Select
                                                placeholder="Select"
                                                allowClear
                                            >
                                                <Option value="1">1</Option>
                                                <Option value="2">2</Option>
                                                <Option value="3">3</Option>
                                                <Option value="4">4</Option>
                                            </Select>

                                        </Form.Item>
                                    </AntdCol>
                                </AntdRow>
                                <AntdRow className="justify-content-center">
                                    <AntdCol>
                                        <AntdButton type="primary" className="me-1" htmlType="submit"
                                                    loading={searchLoading}
                                                    onClick={() => {
                                                        if (pageIndex === 1) {
                                                            search();
                                                            return;
                                                        }
                                                        setPageIndex(1);
                                                    }}
                                        >
                                            Search
                                        </AntdButton>
                                        <AntdButton type="default" loading={searchLoading} onClick={() => {
                                            form.resetFields();
                                            if (pageIndex === 1) {
                                                search();
                                                return;
                                            }
                                            setPageIndex(1);
                                        }}>
                                            Reset
                                        </AntdButton>
                                    </AntdCol>
                                </AntdRow>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <Table
                                loading={searchLoading}
                                rowKey={"noNumber"}
                                className="table table-hover m-0 table-centered dt-responsive nowrap w-100"
                                dataSource={episodeCaptureImages}
                                columns={columns}
                                pagination={false}
                            />

                            {episodeCaptureImages?.length !== 0 && (
                                <CustomPagination
                                    pageIndex={pageIndex}
                                    pageSize={pageSize}
                                    totalItem={totalRecord}
                                    setPageSize={setPageSize}
                                    setPageIndex={setPageIndex}
                                />
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default EpisodeCaptureImage;
